/**
 * Search as a prompt (S2) — when the search box reads as a COMMAND rather than a term.
 *
 * "open the research about math", "go to onboarding", "where is the pricing doc" are requests
 * to be taken somewhere, not words to match against bodies. The pattern is deliberately a
 * leading-verb list: a plain term that happens to contain one of these words mid-sentence
 * ("the open questions") is still a search.
 *
 * S4 — work items too: "find the ticket about loader", "find my task on deploys", and a tile
 * named by its key ("open GAME-12"). The key alternative is subsumed by the leading `open`
 * today; it is written out so a tile key stays a command even if the verb list is ever
 * tightened, and so the intent is on the page.
 */
export const COMMAND_PATTERN =
  /^(open|show|go to|take me to|find (the|a|my)? ?(research|doc|document|collection|work item|task|ticket|item|issue|bug)|where is)\b|^(open|show|go to)\s+[A-Z]{2,8}-\d+\b/i;

export function isCommandQuery(query: string): boolean {
  return COMMAND_PATTERN.test(query.trim());
}
